export enum SearchOptionType {
    VIEW_MODE = 1,
    SORT = 2
}
